import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { resetLoginFlag } from "../../slices/thunks";
import { login } from "../../slices/qaManagment/authentication/thunk";
import logoLight from "../../assets/qaManagemet/AntsQualityLightLogo.png";
import { createSelector } from "reselect";
import { getLoggedInUser } from "../../helpers/fakebackend_helper";
import logoDark from "../../assets/images/sebs-logo.png";
import { toast } from "react-hot-toast";
// import loginPic from '../../assets/qrcode/qrLogin.jpg'
import landingImage from "../../assets/qrcode/Optimized-Landing.jpeg";


const Login = (props) => {
  const authuser = getLoggedInUser();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
  const loginerror = useSelector((state) => state.Auth.errorMsg);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [username, setusername] = useState("");
  const handleClick = () => {
    navigate("/register");
  };

  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));

  const { user, error, errorMsg } = useSelector(loginpageData);

  const [userLogin, setUserLogin] = useState([]);
  const [passwordShow, setPasswordShow] = useState(false);

  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (user) {
      const updatedUserData =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? user.multiFactor.user.email
          : user.user.email;
      const updatedUserPassword =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? ""
          : user.user.confirm_password;
      setUserLogin({
        username: updatedUserData,
        password: updatedUserPassword,
      });
    }
  }, [user]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        dispatch({ type: "LOGIN_LOADING" });

        await dispatch(login(values, props.router.navigate));

        if (
          isAuthenticated &&
          (authuser.associatedRoles.includes("SuperAdmin") ||
            authuser.associatedRoles.includes("SystemAdmin"))
        ) {
          navigate("/dashboard");
        } else if (
          isAuthenticated &&
          authuser.associatedRoles.includes("SystemUser")
        ) {
          navigate("/project");
        }
      } catch (error) {
        console.error("Login failed:", error);
      } finally {
        setLoading(false);
        dispatch({ type: "LOGIN_LOADED" });
      }
    },
  });

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  const handleForgotPasswordClick = () => {
    console.log(username);
    navigate(`/forgot-password-change`);
  };

  document.title = "Login || QR Code Menu";
  
  // textanimation

  const texts = [
    "Order ready-to-use stickers right away!",
    "Build a digital menu accessible by a QR code easy and fast.",
    "Eliminate the need for physical menus, reducing printing costs."
  ];

  const [currentText, setCurrentText] = useState(texts[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prev) => {
        const currentIndex = texts.indexOf(prev);
        const nextIndex = (currentIndex + 1) % texts.length;
        return texts[nextIndex];
      });
    }, 5000);


    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);

  return (
    <React.Fragment>
      <ParticlesAuth>
        <Container>
          <Row className="g-0 justify-content-center align-items-stretch">
          <Col md={6} lg={6} xl={6} sm={12} xs={12} className="position-relative ">
            <img src={landingImage} alt="Login Illustration" className="object-fit-cover h-100 w-100"/>
            <div className="position-absolute bottom-0 start-0 w-100 h-100 d-flex flex-column justify-content-end text-white text-center p-3">
            <p className="mb-2 fs-3 fw-bold">{currentText}</p>
            </div>
          </Col>
            <Col  md={6} lg={6} xl={6} sm={12} xs={12}>
              <Card className="h-100 border-0 rounded-0">
                <CardBody className="p-4">
                  <div className="text-start p-2 mt-2">
                    <h5 className="text-primary">Welcome Back!</h5>
                    <p className="text-muted">
                      Sign in to continue to QR code Menu admin panel.
                    </p>
                  </div>
                  {errorMsg && errorMsg ? (
                    <Alert color="danger"> {errorMsg} </Alert>
                  ) : null}
                  <div className="p-2 mt-4">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                      action="#"
                    >
                      <div className="mb-3">
                        <Label htmlFor="username" className="form-label fw-bold">
                          Email
                        </Label>
                        <Input
                          name="username"
                          className="form-control"
                          placeholder="Enter email"
                          type="text"
                          onChange={(e) => {
                            validation.handleChange(e);
                            setusername(e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.username || ""}
                          invalid={
                            validation.touched.username &&
                            validation.errors.username
                              ? true
                              : false
                          }
                        />
                        {validation.touched.username &&
                        validation.errors.username ? (
                          <FormFeedback type="invalid">
                            {validation.errors.username}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3 mt-1">
                        <div className="float-end">
                          <Link
                            // to="/forgot-password-change/:${username}``"
                            to="/forgot-password-change"
                            className="text-muted"
                            onClick={handleForgotPasswordClick}
                          >
                            Forgot password?
                          </Link>
                        </div>
                        <Label className="form-label fw-bold" htmlFor="password-input">
                          Password
                        </Label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={passwordShow ? "text" : "password"}
                            className="form-control pe-5"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                          <button
                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={() => setPasswordShow(!passwordShow)}
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                        </div>
                      </div>

                      <div className="form-check">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="auth-remember-check"
                        />
                        <Label
                          className="form-check-label"
                          htmlFor="auth-remember-check"
                        >
                          Remember me
                        </Label>
                      </div>
                      <div className="mt-4 mb-3">
                        <Button
                          disabled={error ? null : loading ? true : false}
                          color="success"
                          className="w-100"
                          type="submit"
                          style={{ backgroundColor: "#0bb29c", borderColor: "#0bb29c", color: "#fff" }}
                        >
                          {loading ? (
                            <Spinner size="sm" className="me-2">
                              Loading...
                            </Spinner>
                          ) : null}
                          Sign In
                        </Button>
                      </div>
                      <div className="mt-3 ">
                        <Link to={`/register`}>Register Here!</Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
